<template>
    <div class="event-for-artist" :style="{ width: width <= 600 ? '80%' : '100%' }">
        <div
            v-for="(artist, index) in artists"
            :key="index"
            @mouseover="artist.expand = true"
            :class="artist.expand ? { 'expand-card': true } : {}"
            class="event-card-small"
        >
            <div class="event-top">
                <div class="date">
                    {{ artist.date }}
                    <span v-if="!artist.expand">...</span>
                </div>
                <div v-if="!artist.expand" class="call-to-action-wrapper">
                    <button class="call-to-action-btn">
                        {{ width >= 900 ? 'Invitation Received' : ' Received' }}
                    </button>
                </div>
                <div v-if="artist.expand && width >= 900" class="doors">
                    <span>Doors @{{ artist.doors }}</span>
                </div>
                <div v-if="artist.expand" class="budget-for-artist">
                    <span v-if="width >= 900">Budget:</span> {{ artist.budget }} for
                    {{ artist.artist_count }} artists
                </div>
            </div>
            <transition>
                <div v-if="artist.expand" class="event-bottom">
                    <div class="event-organization">
                        <div class="user-img">
                            <img :src="artist.avatar" class="user-photo" />
                        </div>
                        <div class="invite">
                            <span
                                ><span v-if="width >= 900">Invited by</span>
                                {{ artist.invite }}</span
                            >
                        </div>
                    </div>
                    <div class="call-to-action-wrapper">
                        <button @click="redirectToArtistReg" class="call-to-action">
                            <span class="artist-create-acc-text">{{
                                width >= 900 ? 'Make an offer' : 'Offer'
                            }}</span>
                        </button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import checkScreen from '../../../mixins/check-screen'
    import { useAuth } from '@/composables/auth/useAuth'

    export default {
        name: 'EventCard',
        mixins: [checkScreen],
        setup() {
            const { handleShowRegisterModal } = useAuth()

            return {
                handleShowRegisterModal
            }
        },
        data() {
            return {
                showElement: false,
                artists: [
                    {
                        date: 'Sat, July 15',
                        doors: '8:00 PM',
                        invite: 'Fernando Hideaway',
                        budget: '$600',
                        artist_count: 2,
                        avatar: '/images/icons/message-flow/dreambot.svg',
                        expand: false
                    },
                    {
                        date: 'Fri, July 24',
                        doors: '9:00 PM',
                        invite: 'The Shredder',
                        budget: '$850',
                        artist_count: 2,
                        avatar: '/images/icons/message-flow/maxine.svg',
                        expand: false
                    },
                    {
                        date: 'Thurs, Aug 3rd',
                        doors: '6:00 PM',
                        invite: 'Rick`s Cafe American',
                        budget: '$350',
                        artist_count: 1,
                        avatar: '/images/icons/message-flow/pixel.svg',
                        expand: false
                    }
                ]
            }
        },

        methods: {
            redirectToArtistReg() {
                this.handleShowRegisterModal()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    @media (max-width: 600px) {
        .event-card-small {
            padding: 16px !important;
        }
        .call-to-action {
            width: 100%;
        }
        .date {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 170px;
            margin-left: 0 !important;
        }
        .event-for-artist {
            justify-content: flex-start !important;
            align-items: flex-start;
        }
    }
    @media (max-width: 1100px) {
        .event-for-artist {
            flex: 0 0 100% !important;
        }
    }
    .v-enter {
        max-height: 0;
    }
    .v-enter-to {
        max-height: 165px;
    }
    .v-enter-active {
        transition: max-height 1s linear;
    }
    .call-to-action-btn {
        padding: 11px 50px 12px 50px;
        border-radius: 100px;
        border: 1px solid #cdeb09;
        background: #262626;
        color: var(--green, #cdeb09);
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .event-for-artist {
        display: flex;
        flex-direction: column;
        flex: 0 0 40%;
        min-height: 500px;
        justify-content: center;
    }
    .event-top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
    }

    .event-bottom {
        display: flex;
        justify-content: flex-start;
        align-items: baseline;
    }

    .event-card-small {
        display: flex;
        flex-direction: column;
        padding: 25px 30px 25px 20px;
        justify-content: space-between;
        margin-bottom: 15px;
        border-radius: 15px;
        background: #262626;
        overflow: hidden;
        width: 100%;
    }

    .date {
        margin-left: 15px;
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }

    .doors {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin-left: 15px;
    }

    .invite {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        padding-left: 15px;
    }

    .event-organization {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 20px;
    }

    .user-photo {
        max-width: 40px;
        border-radius: 50%;
    }

    .budget-for-artist {
        color: var(--green, #cdeb09);
        text-align: center;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin-left: auto;
    }
    .call-to-action-wrapper {
        margin-left: auto;
    }
    .call-to-action {
        padding: 11px 50px 12px 50px;
        border-radius: 100px;
        background: #cdeb09;
        border: none;
    }
    .artist-create-acc-text {
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
</style>
